export default "__VITE_ASSET__76b2c4ac__"